/**
 * Identité de la version en cours d'exécution.
 *
 * # Pourquoi c'est figé à la compilation
 *
 * Une route `/api/version` serait la façon évidente de servir cette
 * information. Ce serait aussi une invocation de Function **par ouverture de
 * l'écran de réglages**, donc une ponction sur le quota de 100 000 requêtes du
 * compte — pour une donnée qui ne change jamais entre deux déploiements. Les
 * assets statiques de Pages, eux, sont illimités et gratuits (cf. CLAUDE.md
 * § 5). L'information est donc gravée dans le bundle par `vite.config.ts`.
 *
 * # Pourquoi c'est utile, et pas cosmétique
 *
 * L'application est une PWA : le service worker sert la version déjà installée
 * tant que la mise à jour n'a pas été acceptée. Un téléphone peut donc faire
 * tourner un build vieux de plusieurs jours pendant qu'un autre a le dernier.
 * Ce que cet écran affiche est la version **réellement exécutée sur cet
 * appareil** — la seule façon de répondre, sans deviner, à « est-ce que mon
 * déploiement est bien arrivé sur ce téléphone ? ».
 */

// Remplacés littéralement à la compilation. Absents sous vitest, d'où le
// `typeof` : sans lui, l'import lèverait une ReferenceError.
declare const __APP_VERSION__: string | undefined;
declare const __APP_COMMIT__: string | undefined;
declare const __APP_BUILT_AT__: number | undefined;

/** Numéro de version, aligné sur `package.json`. */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';

/** Commit court d'où provient ce build, ou `null` hors dépôt git. */
export const APP_COMMIT: string | null =
  typeof __APP_COMMIT__ === 'string' && __APP_COMMIT__.length > 0 ? __APP_COMMIT__ : null;

/** Date de compilation, en epoch ms UTC — comme tous les horodatages du projet. */
export const BUILT_AT: number | null = typeof __APP_BUILT_AT__ === 'number' ? __APP_BUILT_AT__ : null;
